import React from "react";
import "./PricingSection.css";
import paymentIcons from "assets/payment.webp"; // Importing the new image
import { useNavigate } from "react-router-dom";
// You might need an SVG for the lock icon
// import { ReactComponent as LockIcon } from 'assets/lock.svg';

export default function PricingSection() {
  const navigate = useNavigate();

  return (
    <section className="pricing-section" id="pricing">
      <h2 className="pricing-heading">
        If you're ready to get millions of views and dream brand deals, let's get started today.
      </h2>

      <div className="pricing-grid">
        {/* Card 1: Best Savings */}
        <div className="pricing-card">
          {/* <h3 className="card-title savings">Best Savings</h3> */}
          <div style={{ fontWeight: 600, fontSize: '1.2rem', marginBottom: '16px', color: '#23272e', fontFamily: 'inherit' }}>Unlock 50% OFF Today!</div>
          <div className="price-container">
            <p className="original-price-savings">£999</p>
            <p className="final-price-savings">£499</p>
          </div>
          <ul className="pricing-features">
            <li>Was £999, now £499 — Save £500 instantly.</li>
            <li>•⁠  ⁠One-Time Payment</li>
            <li>•⁠  ⁠100% Money-Back Guarantee</li>
          </ul>
          <button className="pricing-button solid" onClick={() => navigate('/checkout')}>Get Access Now</button>
        </div>
      </div>

      <div className="secure-checkout">
        <img src={paymentIcons} alt="Secure Payment Methods" className="payment-methods" />
      </div>
    </section>
  );
} 